if (!customElements.get("copy-clipboard")) {
  class CopyClipboard extends HTMLElement {
    constructor() {
      super();
      this.btn = null;
      this.timeout = null;
    }

    connectedCallback() {
      this.btn = this.querySelector("button");
      this.code = this.getAttribute("data-code");

      if (!this.btn || !this.code) {
        console.error("clipboard: Required elements not found");
        return;
      }

      this.btn.addEventListener("click", () => {
        this.copyToClipboard();
      });
    }

    async copyToClipboard() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.btn.classList.add("isActive");
      await navigator.clipboard.writeText(this.code);
      this.timeout = setTimeout(() => {
        this.btn.classList.remove("isActive");
      }, 750);
    }
  }

  customElements.define("copy-clipboard", CopyClipboard);
}
